import { Button, Grid } from '@mui/material';
import React from 'react';
import SortLabel, { sortDirection } from '../../components/SortLabel';
import { ITimelineOptions } from './TimelineOptions';

interface ITimelineSideBarHeaderProps {
  timelineOptions: ITimelineOptions;
  setTimelineOptions: React.Dispatch<React.SetStateAction<ITimelineOptions>>;
  onResetView: () => void;
}

function TimelineSideBarHeaderRenderer(props: ITimelineSideBarHeaderProps) {
  const { timelineOptions, setTimelineOptions, onResetView } = props;

  const setOrderNameBy = (sortDirection: sortDirection) => {
    setTimelineOptions({
      ...timelineOptions,
      orderNameBy: sortDirection,
      orderUtilisationBy: undefined,
    });
  };

  const setOrderUtilisationBy = (sortDirection: sortDirection) => {
    setTimelineOptions({
      ...timelineOptions,
      orderUtilisationBy: sortDirection,
      orderNameBy: undefined,
    });
  };

  return (
    <Grid container display="flex" alignItems="center" justifyContent="center" spacing={1}>
      <Grid item>
        <Button size="small" onClick={onResetView}>
          Reset to default view
        </Button>
      </Grid>

      <Grid item>
        <SortLabel label={'Name'} orderBy={timelineOptions.orderNameBy} setOrderBy={setOrderNameBy} />
      </Grid>
      <Grid item>
        <SortLabel label={'Util'} orderBy={timelineOptions.orderUtilisationBy} setOrderBy={setOrderUtilisationBy} />
      </Grid>
    </Grid>
  );
}

export default TimelineSideBarHeaderRenderer;
